// extracted by mini-css-extract-plugin
module.exports = {"footerlinks":"styles-module--footerlinks"};